/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.bootstrap_barrio_subtheme = {
    attach: function (context, settings) {
      // Add slideDown animation to Bootstrap dropdown when expanding.
      $('header .nav-item', context).on('show.bs.dropdown', function() {
        // Suppress dropdown behaviour for mobile menu.
        if (window.innerWidth < 992) {
          let linkTarget = $(this).find('a.nav-link').attr('href');
          window.location.href = linkTarget;
          return false;
        } else {
          $(this).find('.dropdown-menu').first().stop(true, true).slideDown(200);
        }
      });

      // Add slideUp animation to Bootstrap dropdown when collapsing.
      $('header .nav-item', context).on('hide.bs.dropdown', function() {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
      });
    }
  };

})(jQuery, Drupal);
